import React, { useState, useEffect } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { styleQuestions } from "./QuestionsStyle";
import Answers from "./Answers";
import clienteAxios from "../../../config/axios";
import Spin from "../../../components/Spin/spin";
import NavQuestion from "./NavQuestion";
import ImgData from "../../../images/Consulting-rafiki.svg";
import CalificarCurso from "./CalificarCurso";
import { useNavigate, useParams } from "react-router-dom";

export default function Questions(props) {
  const theme = useTheme();
  const classes = styleQuestions(theme);
  const navigate = useNavigate();
  const { idCurso, slug } = useParams();

  let user = { _id: "" };
  const token = localStorage.getItem("token");

  if (token !== null) user = JSON.parse(localStorage.getItem("student"));

  const [dataQuestions, setDataQuestions] = useState([]);
  const [allResponseUser, setAllResponseUser] = useState([]);

  const [actiallyQuestion, setActiallyQuestion] = useState({});
  const [answersSelected, setAnswersSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [calificar, setCalificar] = useState(false);

  const getQuestions = async () => {
    try {
      setLoading(true);
      const data = await clienteAxios.get("/question");
      setDataQuestions(data.data);
      if (data.data.length > 0) {
        setActiallyQuestion({
          index: 0,
          data: data.data[0],
        });
        setLoading(false);
      } else {
        //Redirect to home - dash
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  const saveAnswersUser = async () => {
    try {
      await clienteAxios.post(
        `/question/answers/course/${idCurso}/user/${user?._id}`,
        [...allResponseUser, ...answersSelected],
        {
          headers: {
            Authorization: `bearer ${token}`,
          },
        },
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleClickNextAndFinish = async () => {
    if (answersSelected.length < 1) return;
    setLoading(true);
    const next = actiallyQuestion.index + 1;
    if (next > dataQuestions.length - 1) {
      await saveAnswersUser();
      setActiallyQuestion({
        ...actiallyQuestion,
        index: next,
      });
      setCalificar(true);
    } else {
      setAllResponseUser([...allResponseUser, ...answersSelected]);
      setActiallyQuestion({
        index: next,
        data: dataQuestions[next],
      });
      setAnswersSelected([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    getQuestions();
  }, []);

  if (!token || !user) {
    navigate("/");
  }

  if (loading) {
    return <Spin loading={loading} />;
  }

  return (
    <div style={classes.fatherContent}>
      <Box sx={classes.content}>
        <NavQuestion
          actiallyQuestion={actiallyQuestion}
          dataQuestions={dataQuestions}
        />
        {!calificar ? (
          <>
            <p style={classes.title}>
              Estamos trabajando para ofrecerte mejor contenido de calidad.
            </p>
            <p style={classes.subTitle}>
              Ayúdanos a responder está pequeña encuesta, tomate el tiempo
              necesario para contestarla.
            </p>
          </>
        ) : (
          <>
            <Typography
              sx={classes.title}
              style={{ textAlign: "center", marginBottom: "20px" }}
            >
              ¿Te gustaría calificar el curso?
            </Typography>
            <Typography style={{ textAlign: "center" }} sx={classes.subTitle}>
              ¡Danos tu opinión para mejorar!
            </Typography>
          </>
        )}

        {calificar ? (
          <CalificarCurso
            setLoading={setLoading}
            idCurso={idCurso}
            props={props}
            slug={slug}
          />
        ) : (
          <ContentQuestions
            answersSelected={answersSelected}
            setAnswersSelected={setAnswersSelected}
            actiallyQuestion={actiallyQuestion}
            classes={classes}
            handleClickNextAndFinish={handleClickNextAndFinish}
            idCurso={idCurso}
          />
        )}
      </Box>
    </div>
  );
}

function ContentQuestions({
  classes,
  actiallyQuestion,
  answersSelected,
  setAnswersSelected,
  handleClickNextAndFinish,
  idCurso,
}) {
  if (!actiallyQuestion) return <p>a</p>;
  return (
    <div style={classes.contentQuestion}>
      <p style={classes.questionStyle}>
        {" "}
        {actiallyQuestion?.index + 1}.-{" "}
        {actiallyQuestion?.data?.question?.question}
      </p>
      <div
        style={{
          display: "flex",
        }}
      >
        <Answers
          answers={actiallyQuestion?.data?.answers}
          answersSelected={answersSelected}
          setAnswersSelected={setAnswersSelected}
          textQuestion={actiallyQuestion?.data?.question?.question}
          idCurso={idCurso}
        />
        <div>
          <img
            style={classes.imgQuestion}
            alt={"imagen preguntas"}
            src={ImgData}
          />
        </div>
      </div>

      <Box sx={classes.contentButtonNext}>
        <Button
          sx={classes.buttonNext}
          variant="contained"
          size="medium"
          color="primary"
          onClick={() => handleClickNextAndFinish()}
        >
          Siguiente
        </Button>
      </Box>
    </div>
  );
}
